"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merchantCityRulesListApi = merchantCityRulesListApi;
exports.merchantPolygonRulesByDelete = merchantPolygonRulesByDelete;
exports.merchantPolygonRulesListApi = merchantPolygonRulesListApi;
exports.merchantRulesByDelete = merchantRulesByDelete;
exports.queryOrderBill = queryOrderBill;
exports.queryOrderDetail = queryOrderDetail;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function merchantCityRulesListApi(params) {
  return (0, _request.default)({
    url: '/merchant/virtual/dd/merchant/city/rules/list',
    method: 'get',
    params: params
  });
}
function merchantPolygonRulesListApi(params) {
  return (0, _request.default)({
    url: '/merchant/virtual/dd/merchant/polygon/rules/list',
    method: 'get',
    params: params
  });
}
function merchantRulesByDelete(id) {
  return (0, _request.default)({
    url: '/merchant/virtual/dd/merchant/rules/delete/' + id,
    method: 'get'
  });
}
function merchantPolygonRulesByDelete(id) {
  return (0, _request.default)({
    url: '/merchant/virtual/dd/merchant/polygon/rules/delete/' + id,
    method: 'get'
  });
}
function queryOrderDetail(data) {
  // data.rules = pram.rules.join(',')
  return (0, _request.default)({
    url: '/merchant/virtual/dd/queryOrderDetail',
    method: 'POST',
    data: data
  });
}
function queryOrderBill(data) {
  // data.rules = pram.rules.join(',')
  return (0, _request.default)({
    url: '/merchant/virtual/dd/queryOrderBill',
    method: 'POST',
    data: data
  });
}